import Axios from 'axios';
import { buildWebStorage, setupCache } from 'axios-cache-interceptor';

const instance = Axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

const cachedAxios = setupCache(instance, {
    storage: buildWebStorage(localStorage, 'axios-cache:'),
    ttl: 1000 * 60 * 30, // 30 minutes
    interpretHeader: false,
    cachePredicate: {
        statusCheck: status => [200, 203, 204, 300, 301, 302, 404, 405, 410, 414, 501].includes(status),
    },
});

export default cachedAxios;
